module.exports = __webpack_public_path__ + "static/img/4331_phase_function_Paper_PointsHejduk_Prediction.ab95765.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4331_phase_function_Paper_PointsHejduk_Prediction.png
// module id = y16S
// module chunks = 0